export const fileUploadTypes = {
    SetDestination: "[FileUpload] Set Destination",
    SetUpload: "[FileUpload] Set upload",
    CleanUp: "[FileUpload] Clean upload",
    FillDocuments: "[FileUpload] Fill Documents",
};
